module.exports = __webpack_public_path__ + "img/journey.01299b71.svg";